import { RemoveRedEye } from '@mui/icons-material';
import { Box, Chip, IconButton, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import { colors } from '../../assets/utils/colors';

const PromotionWidget = ({ promotion_image, promotion_name, status, id }) => {
    return (
        <>
            <Box
                sx={{
                    'borderRadius': 3,
                    'overflow': 'hidden',
                    'border': `1px solid ${colors.bgColor1}`,
                    'background': `linear-gradient(180deg, ${colors.bgColor1}, ${colors.bgColor2})`,
                    'transition': '.2s all ease-in-out',
                    ':hover': {
                        transform: 'scale(1.01)',
                        transition: '.2s all ease-in-out',
                        boxShadow: `2px 2px 10px 4px ${colors.bgColor3}`,
                    },
                }}
            >
                <Box>
                    <img
                        src={promotion_image}
                        alt=""
                        style={{
                            width: '100%',
                            height: 150,
                            objectFit: 'contain',
                        }}
                    />
                </Box>
                <Box
                    sx={{
                        background: `linear-gradient(180deg, ${colors.bgColor1}, ${colors.bgColor1})`,
                        p: 1.5,
                    }}
                >
                    <Typography
                        sx={{
                            fontWeight: 'bold',
                            color: colors.primary,
                            fontSize: 13,
                        }}
                    >
                        {promotion_name}
                    </Typography>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        mt: 0.5,
                    }}
                >
                    <Box
                        sx={{
                            width: '100%',
                            textAlign: 'center',
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: 12,
                                fontWeight: 'bold',
                            }}
                        >
                            Products
                        </Typography>
                        <Typography sx={{ fontSize: 13 }}>50</Typography>
                    </Box>
                    <Box
                        sx={{
                            width: '100%',
                            textAlign: 'center',
                            borderLeft: '1px solid green',
                            borderRight: '1px solid green',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        {status ? (
                            <Chip size="small" color="success" label="active" />
                        ) : (
                            <Chip size="small" color="error" label="inactive" />
                        )}
                    </Box>
                    <Box
                        sx={{
                            width: '100%',
                            textAlign: 'center',
                        }}
                    >
                        <Tooltip title="Promotion details">
                            <Link to={`/promotions/details/${id}`}>
                                <IconButton color="info">
                                    <RemoveRedEye />
                                </IconButton>
                            </Link>
                        </Tooltip>
                    </Box>
                </Box>
            </Box>
        </>
    );
};

export default PromotionWidget;
